import { defineComponent } from 'vue';
import { AppGeneralVariables } from 'src/plugins/general/variables';
import { useViewStore } from 'src/stores/view';
import { openWindowPlugin } from "src/plugins/general/openWindow";
export default defineComponent({
    setup() {
        const { styleType } = AppGeneralVariables();
        const viewStore = useViewStore();
        const { openWindow } = openWindowPlugin();
        function goexturl(value) {
            if (value === 'facebook') {
                openWindow({ url: 'https://www.facebook.com/bookgospaces' });
            }
            else if (value === 'instagram') {
                openWindow({ url: 'https://www.instagram.com/getspaces.com/' });
            }
            else if (value === 'linkedin') {
                openWindow({ url: 'https://www.linkedin.com/company/bookgospaces/' });
            }
            else if (value === 'whatsapp') {
                openWindow({ url: 'https://wa.me/6597518965' });
            }
        }
        function hideFAB() {
            viewStore.togglePermaFAB(false);
        }
        return {
            styleType,
            goexturl,
            hideFAB
        };
    }
});
